import script from "./admin-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-layout.vue?vue&type=script&setup=true&lang=js"

import "./admin-layout.vue?vue&type=style&index=0&id=1ffe9178&lang=scss&scoped=true"
import "./admin-layout.vue?vue&type=style&index=1&id=1ffe9178&lang=scss"

import exportComponent from "/home/atsuser/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffe9178"]])

export default __exports__